import { hasCapability, type User } from "../base";

export const worksite = {
  read: (user: User) => hasCapability(user, "worksite.read"),
  accountManager: {
    transfer: (user: User) => hasCapability(user, "worksite.accountManager.transfer"),
  },
  address: {
    overridePhaseGate: (user: User) => hasCapability(user, "worksite.address.overridePhaseGate"),
  },
};
